<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li class="s">
            <a href="javascript:;">{{ $t('newsnava')}}</a>
          </li>
          <li @click="$router.push({name: 'building'})">
            <a href="javascript:;">{{ $t('newsnavb')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="page-main">
      <div class="w1200">
        <ul class="newslist">
          <li class="bounceInUp wow" v-for="(data ,index) in newslist" :key="index" @click="$router.push({name: 'newspage',params:{id: data.id}})" data-wow-duration="1s" data-wow-delay="0.3s">
            <div class="picbox amn3">
              <img :src="data.image" :alt="data.title" class="amn3">
            </div>
            <div class="cont">
              <h1>{{data.title}}</h1>
              <span class="sp1">{{data.update_time}}</span>
              <div class="desc">{{data.describe}}</div>
              <a href="javascript:;" :title="data.title" class="amn3">MORE></a>
            </div>
          </li>
        </ul>
        <div class="newslist-pageindex">
          <a href="javascript:;" @click="page(1)">{{ $t('first')}}</a>
          <a href="javascript:;" @click="page(cur-1)">{{ $t('prev')}}</a>
          <a href="javascript:;" v-if="cur > 2 && all!=2">...</a>
          <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
          <a href="javascript:;" v-if="all > cur && all > 2">...</a>
          <a href="javascript:;" @click="page(cur+1)">{{ $t('next')}}</a>
          <span>{{ $t('all')}}{{alllength}}{{ $t('tiao')}} {{ $t('gong')}}{{all}}{{ $t('ye')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      newslist: [],
      postid: 1,
      all: 1,
      cur: 1,
      pageindexarr: [],
      alllength: 1
    }
  },
  mounted () {
  },
  methods: {
    page (index) {
      const that = this
      console.log(index)
      console.log(that.all)
      if (index <= 0) {
        index = 1
      }
      if (index >= this.all) {
        index = this.all
      }
      if (index === 1) {
        if (this.all < 2) {
          this.pageindexarr = [1]
        } else {
          this.pageindexarr = [1, 2]
        }
      } else if (index === 2) {
        if (this.all < 3) {
          this.pageindexarr = [1, 2]
        } else {
          this.pageindexarr = [1, 2, 3]
        }
      } else {
        if (this.all < index + 1) {
          this.pageindexarr = [index - 1, index]
        } else {
          this.pageindexarr = [index - 1, index, index + 1]
        }
      }
      if (index === this.cur) {
        return false
      }
      this.cur = index
      Fetch.post('Api/news?page=' + index, {
        classify_id: that.postid,
        limit: 9
      }).then((res) => {
        that.newslist = res.result.data
        that.all = res.result.last_page
        that.alllength = res.result.total
      })
    }
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 6
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    if (localStorage.getItem('lang') === 'cn' || localStorage.getItem('lang') === null) {
      that.postid = 1
    } else {
      that.postid = 3
    }
    Fetch.post('Api/news', {
      classify_id: that.postid,
      limit: 9
    }).then((res) => {
      that.newslist = res.result.data
      that.all = res.result.last_page
      that.alllength = res.result.total
      if (that.all >= 2) {
        that.pageindexarr = [1, 2]
      } else {
        that.pageindexarr = [1]
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner6{
    background: url(../assets/pagebanner6.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    width: 168px;
    height: 60px;
    margin: 0 3px;
  }
  .pagenav li a{
    display: block;
    width: 100%;
    height: 100%;
    line-height: 60px;
    text-align: center;
    color: #999999;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .page-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
  .newslist{
    width: 1222px;
    height: auto;
    overflow: hidden;
    display: flex;
    margin-top: 80px;
    flex-wrap: wrap;
  }
  .newslist li{
    width: 385px;
    height: 415px;
    overflow: hidden;
    background: #F7F7F7;
    margin-right: 22px;
    cursor: pointer;
    margin-bottom: 22px;
  }
  .newslist li .picbox{
    width: 100%;
    height: 150px;
  }
  .newslist li .picbox img{
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
  .newslist li .cont{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0 24px;
  }
  .newslist li .cont h1{
    display: block;
    width: 100%;
    height: 56px;
    line-height: 28px;
    margin-top: 23px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  .newslist li .cont span{
    display: block;
    width: 100%;
    height: 22px;
    line-height: 22px;
    margin-top: 14px;
    font-weight: bold;
    color: #333;
  }
  .newslist li .cont .desc{
    display: block;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 60px;
    color: #999;
    line-height: 30px;
  }
  .newslist li .cont a{
    display: flex;
    width: 68px;
    height: 30px;
    color: #999999;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .newslist li:hover .picbox, .newslist li:hover .picbox img{
    height:180px;
  }
  .newslist li:hover span{
    color: #e40a1f;
  }
  .newslist li:hover a{
    background-color: #e40a1f;
    color: #fff
  }
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 15px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #E40A1F;color:#fff}
  .newslist-pageindex a:hover{background-color: #E40A1F;color:#fff}
</style>



// WEBPACK FOOTER //
// src/pages/newslist.vue